import {Box, IconButton, Stack, Typography} from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';

interface IFullscreenFailedContentProps {
    onClose: () => void;
}

export const FullscreenFailedContent = ({onClose}: IFullscreenFailedContentProps) => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '80vw',
                height: '50vh',
                backgroundColor: 'rgba(0, 0, 0, 0.95)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'white',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    },
                }}
            >
                <CloseIcon />
            </IconButton>
            <Stack alignItems="center" spacing={2}>
                <ErrorOutlineIcon sx={{color: '#ff4444', fontSize: 48}} />
                <Typography variant="h6" sx={{color: '#ff4444'}}>
                    Generation failed
                </Typography>
            </Stack>
        </Box>
    );
};
